import Grid from '@mui/material/Unstable_Grid2/Grid2';
import {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import AllServicesIcon from '@icons/AllServicesIcon';
import ServicePatternIcon from '@icons/ServicePatternIcon';
import socket, {IResponse} from '@sockets';
import Service from '../services/Service';
import {servicesList} from '../services/ServiceList';

interface ITopService {
	id: number,
	serviceId: number,
	order: number
}

export default function TopServices() {
	const {t} = useTranslation();
	const defaultServiceIds: ITopService[] = JSON.parse(localStorage.getItem('top_services') ??
		'[{"serviceId": 30, "order": 1}, {"serviceId": 10, "order": 2}, {"serviceId": 8, "order": 3}, {"serviceId": 2, "order": 4}, {"serviceId": 4, "order": 5}]');
	const defaultServices = servicesList.filter(service => defaultServiceIds.some(item => item.serviceId === service.id))
		.sort((a, b) => {
			const serviceA = defaultServiceIds.find(item => item.serviceId === a.id) ?? {order: 0};
			const serviceB = defaultServiceIds.find(item => item.serviceId === b.id) ?? {order: 0};
			return serviceA.order - serviceB.order;
		});
	const allServices = {
		id: -1,
		name: 'all_services',
		icon: <ServicePatternIcon><AllServicesIcon/></ServicePatternIcon>,
		link: '/services'
	};
	defaultServices.push(allServices);
	const [services, setServices] = useState(defaultServices);
	
	useEffect(() => {
		socket.emit('home:top_services', null, (data: IResponse<ITopService[]>) => {
			if (data.success) {
				localStorage.setItem('top_services', JSON.stringify(data.result));
				const services = servicesList.filter(service => data.result.some(item => item.serviceId === service.id))
					.sort((a, b) => {
						const serviceA = data.result.find(item => item.serviceId === a.id) ?? {order: 0};
						const serviceB = data.result.find(item => item.serviceId === b.id) ?? {order: 0};
						return serviceA.order - serviceB.order;
					});
				services.push(allServices);
				setServices(services);
			}
		});
	}, []);
	return (
		<Grid container className="py-4">
			{
				services.map((service) => <Grid className="relative" key={service.id} xs={4}>
					<Service service={service}/>
				</Grid>)
			}
		</Grid>
	);
}
